'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Event's name for tracking
 * @type {string}
 */
var EVENT_LOG_IN = exports.EVENT_LOG_IN = 'Login';
var EVENT_EMAIL_VERIFICATION = exports.EVENT_EMAIL_VERIFICATION = 'Email Verified';
var EVENT_REGISTRATION = exports.EVENT_REGISTRATION = 'Registration Complete';
var EVENT_SUBSCRIPTION_SALE_ATTEMPT = exports.EVENT_SUBSCRIPTION_SALE_ATTEMPT = 'Subscription Sale Attempt';
var EVENT_SUBSCRIPTION_SALE = exports.EVENT_SUBSCRIPTION_SALE = 'Subscription Sale';

var EVENT_BOOKMAKER_OPEN_ACCOUNT = exports.EVENT_BOOKMAKER_OPEN_ACCOUNT = 'Bookmaker Open Account';
var EVENT_BOOKMAKER_LOGIN = exports.EVENT_BOOKMAKER_LOGIN = 'Bookmaker Login';
var EVENT_BOOKMAKER_LOGIN_SUCCESS = exports.EVENT_BOOKMAKER_LOGIN_SUCCESS = 'Bookmaker Login Success';
var EVENT_BOOKMAKER_LOGIN_FAILURE = exports.EVENT_BOOKMAKER_LOGIN_FAILURE = 'Bookmaker Login Failure';
var EVENT_BOOKMAKER_LOGIN_ATTEMPT = exports.EVENT_BOOKMAKER_LOGIN_ATTEMPT = 'Bookmaker Login Attempt';
var EVENT_BOOKMAKER_REGISTER_BUTTON = exports.EVENT_BOOKMAKER_REGISTER_BUTTON = 'Bookmaker Register Button';
var EVENT_BOOKMAKER_PLACE_BET = exports.EVENT_BOOKMAKER_PLACE_BET = 'Place Bet';
var EVENT_BOOKMAKER_BET_RECEIPT = exports.EVENT_BOOKMAKER_BET_RECEIPT = 'Bet Receipt';
var EVENT_BOOKMAKER_OFFER_CLAIM_CLICK = exports.EVENT_BOOKMAKER_OFFER_CLAIM_CLICK = 'Bookmaker Offer Claim Button';

var EVENT_BETSLIP_ERROR_MESSAGE = exports.EVENT_BETSLIP_ERROR_MESSAGE = 'Betslip Error Message';

var EVENT_BET_BUTTON_CLICK = exports.EVENT_BET_BUTTON_CLICK = 'Odds Button';
var EVENT_REMOVE_SELECTION_BUTTON_CLICK = exports.EVENT_REMOVE_SELECTION_BUTTON_CLICK = 'Remove Selection';
var EVENT_QUICK_STAKE_BUTTONS_CLICK = exports.EVENT_QUICK_STAKE_BUTTONS_CLICK = 'Quick Stake Buttons';
var EVENT_CANCEL_BET_BUTTON_CLICK = exports.EVENT_CANCEL_BET_BUTTON_CLICK = 'Cancel Bet';
var EVENT_DISCARD_SLIP_CLICK = exports.EVENT_DISCARD_SLIP_CLICK = 'Discard Slip';

var EVENT_CARD_CUSTOMISATION = exports.EVENT_CARD_CUSTOMISATION = 'Card Customisation';
var EVENT_HORSE_TRACKING_SETTINGS = exports.EVENT_HORSE_TRACKING_SETTINGS = 'Horse Tracker Settings';

var EVENT_NAVIGATION_CLICK = exports.EVENT_NAVIGATION_CLICK = 'Navigation Click';
var EVENT_FOOTER_CLICK = exports.EVENT_FOOTER_CLICK = 'Footer Click';

var EVENT_BARRIER_SHOW = exports.EVENT_BARRIER_SHOW = 'Barrier';
var EVENT_BARRIER_SUBSCRIBE = exports.EVENT_BARRIER_SUBSCRIBE = 'Barrier Subscribe';
var EVENT_BARRIER_SIGN_IN = exports.EVENT_BARRIER_SIGN_IN = 'Barrier Sign In';

var EVENT_BARRIER_ESSENTIAL_SHOW = exports.EVENT_BARRIER_ESSENTIAL_SHOW = 'Essential subscribe barrier';
var EVENT_BARRIER_ESSENTIAL_SUBSCRIBE = exports.EVENT_BARRIER_ESSENTIAL_SUBSCRIBE = 'Subscribe essential barrier';

var EVENT_BARRIER_ULTIMATE_SHOW = exports.EVENT_BARRIER_ULTIMATE_SHOW = 'Ultimate subscribe barrier';
var EVENT_BARRIER_ULTIMATE_SUBSCRIBE = exports.EVENT_BARRIER_ULTIMATE_SUBSCRIBE = 'Subscribe ultimate barrier';

var EVENT_BARRIER_ULTIMATE_ONLY_SHOW = exports.EVENT_BARRIER_ULTIMATE_ONLY_SHOW = 'Ultimate upgrade barrier';
var EVENT_BARRIER_ULTIMATE_ONLY_UPGRADE = exports.EVENT_BARRIER_ULTIMATE_ONLY_UPGRADE = 'Upgrade ultimate barrier';

var EVENT_BARRIER_SIGNIN_SHOW = exports.EVENT_BARRIER_SIGNIN_SHOW = 'Sign in';
var EVENT_BARRIER_SIGNIN_PASSWORD = exports.EVENT_BARRIER_SIGNIN_PASSWORD = 'Forgotten password';

var EVENT_BETTING_OFFER_CLICK = exports.EVENT_BETTING_OFFER_CLICK = 'Betting Offer Click';

var EVENT_CHECKOUT_STARTED = exports.EVENT_CHECKOUT_STARTED = 'Checkout Started';
var EVENT_CHECKOUT_STEP_VIEWED = exports.EVENT_CHECKOUT_STEP_VIEWED = 'Checkout Step Viewed';
var EVENT_CHECKOUT_STEP_COMPLETED = exports.EVENT_CHECKOUT_STEP_COMPLETED = 'Checkout Step Completed';

var EVENT_COUPON_ENTERED = exports.EVENT_COUPON_ENTERED = 'Coupon Entered';
var EVENT_COUPON_DENIED = exports.EVENT_COUPON_DENIED = 'Coupon Denied';
var EVENT_COUPON_REMOVED = exports.EVENT_COUPON_REMOVED = 'Coupon Removed';
var EVENT_COUPON_APPLIED = exports.EVENT_COUPON_APPLIED = 'Coupon Applied';

var EVENT_OFFER_ACCORDION_CLOSED = exports.EVENT_OFFER_ACCORDION_CLOSED = 'Offer Accordion Closed';
var EVENT_OFFER_ACCORDION_OPENED = exports.EVENT_OFFER_ACCORDION_OPENED = 'Offer Accordion Opened';
var EVENT_ORDER_COMPLETED = exports.EVENT_ORDER_COMPLETED = 'Order Completed';

var EVENT_PACKAGE_UPGRADE = exports.EVENT_PACKAGE_UPGRADE = 'Package Upgrade';
var EVENT_PREFERENCE_UPDATE = exports.EVENT_PREFERENCE_UPDATE = 'Preference Update';

var EVENT_BLUKAI_ODDS_BUTTON_CLICK = exports.EVENT_BLUKAI_ODDS_BUTTON_CLICK = 'Odds_Button_Click';
var EVENT_BLUKAI_BOOKMAKER_LOGIN = exports.EVENT_BLUKAI_BOOKMAKER_LOGIN = 'Bookmaker_Login';
var EVENT_BLUKAI_OPEN_ACCOUNT = exports.EVENT_BLUKAI_OPEN_ACCOUNT = 'Open_Account';

var EVENT_RACE_MATRIX_CLICK = exports.EVENT_RACE_MATRIX_CLICK = 'Todays Race Matrix Click';

var EVENT_RACECARD_OFFER_ACCORDION_OPENED = exports.EVENT_RACECARD_OFFER_ACCORDION_OPENED = 'Racecard Offer Accordion Opened';
var EVENT_RACECARD_OFFER_ACCORDION_CLOSED = exports.EVENT_RACECARD_OFFER_ACCORDION_CLOSED = 'Racecard Offer Accordion Closed';
var EVENT_RACECARD_OFFER_BUTTON_CLICKED = exports.EVENT_RACECARD_OFFER_BUTTON_CLICKED = 'Racecard Offer Button Clicked';
var EVENT_CARD_INDEX_CLICKED = exports.EVENT_CARD_INDEX_CLICKED = 'Card Index Clicked';


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/events.js
// module id = 8
// module chunks = 1